import React, { useState } from 'react';
import AdminSidebar from "../../components/admin/AdminSidebar";
import DashboardHeader from "../../components/admin/DashboardHeader";
import ClientsDirectory from "../../components/clients/ClientsDirectory";
import { useAuth } from "../../contexts/AuthContext";

const ClientManagement = () => {
    const { selectedOrganization, organizations } = useAuth();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [timeRange, setTimeRange] = useState('today');
    const [currency, setCurrency] = useState('CDF');

    return (
        <div className="min-h-screen bg-slate-50 flex">
            <AdminSidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} activeSection="clients" />

            <div className="flex-1 min-h-screen transition-all duration-300 overflow-hidden">
                <div className="min-h-screen p-6">
                    <DashboardHeader
                        timeRange={timeRange}
                        onTimeRangeChange={setTimeRange}
                        currency={currency}
                        onCurrencyChange={setCurrency}
                        onMenuToggle={() => setSidebarOpen(!sidebarOpen)}
                    />
                    <div className="mt-6">
                        <ClientsDirectory
                            selectedOrganization={selectedOrganization}
                            organizations={organizations}
                            currency={currency}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClientManagement;
